/**
 * TODO:
 *    1. 大促标签增加 DONE 还需要确认大小，目前小程序的宽高明显计算有问题
 */
import { createBusinessComponent } from '../utils/create';
import TjSwipe from '../swipe'; // import TjbUserAvatar from '../user-avatar';

import envHelper from '../utils/envHelper.js';
export default createBusinessComponent({
  render: function render() {
    var _vm = this;

    var _h = _vm.$createElement;

    var _c = _vm._self._c || _h;

    return _vm.unit ? _c('a', {
      class: _vm.b(),
      style: _vm.layoutStyleCpd,
      attrs: {
        "src": _vm.navUrlCpd
      },
      on: {
        "click": _vm.unitClick
      }
    }, [_c('div', {
      class: _vm.b('picture'),
      style: _vm.imgLayoutStyleCpd
    }, [_vm.isMounted && _vm.isSwipe && _vm.unit.pictureList && _vm.unit.pictureList.length > 0 ? _c('div', {
      class: _vm.b('picture__swipe')
    }, [_c('tj-swipe', {
      class: _vm.b('picture__swipe__com'),
      attrs: {
        "indicator-color": "white"
      },
      scopedSlots: _vm._u([{
        key: "indicators",
        fn: function fn(slotProps) {
          return _c('div', {}, [_c('span', {
            class: _vm.b('picture__swipe__indicators')
          }, _vm._l(_vm.indicatorCountCpd, function (i) {
            return _c('i', {
              key: i,
              class: _vm.indicatorAutoBem('picture__swipe__indicators__item', i, slotProps.activeIndicator)
            });
          }))]);
        }
      }])
    }, _vm._l(_vm.unit.pictureList, function (image, index) {
      return _c('tj-swipe-item', {
        key: index
      }, [_c('img', {
        directives: [{
          name: "lazy",
          rawName: "v-lazy",
          value: image,
          expression: "image"
        }],
        staticClass: "tjf-img-background",
        class: _vm.b('picture__img')
      })]);
    }))], 1) : _c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: _vm.unit.defaultPicture,
        expression: "unit.defaultPicture"
      }],
      staticClass: "tjf-img-background",
      class: _vm.b('picture__img')
    }), _vm.unit.promotionPicUrl && _vm.isShowPromotion ? _c('img', {
      staticClass: "u-promotion",
      attrs: {
        "src": _vm.unit.promotionPicUrl
      }
    }) : _c('div', [_vm.unit.topListTag ? _c('div', {
      staticClass: "top-list-tag",
      style: _vm.topListTagStyle(_vm.unit.topListTag)
    }, [_c('span', {
      staticClass: "text"
    }, [_vm._v(_vm._s(_vm.unit.topListTag.text))])]) : _vm._e()]), _c('div', {
      staticClass: "m-footer-tag"
    }, [_c('div', {
      style: _vm.houseListTagStyle(_vm.unit.houseListTagImage)
    }), _vm.unit.showHouseVR ? _c('i', {
      staticClass: "icon-unit-vr tag-margin"
    }) : _vm._e(), _vm.unit.showHouseVideo ? _c('i', {
      staticClass: "icon-unit-video tag-margin"
    }) : _vm._e()]), _vm.isShowFavorite ? _c('span', {
      class: _vm.b('picture__favorite', _vm.unit.isFavorite ? 'favorite' : 'unfavorite'),
      on: {
        "click": function click($event) {
          $event.stopPropagation();
          return _vm.favoriteClick($event);
        }
      }
    }) : _vm._e(), _vm._t("picture-full"), _vm.unit.failType ? _c('div', {
      class: _vm.b('picture__booking', 'unbooking-' + _vm.unit.failType)
    }) : _vm._e()], 2), _c('div', {
      class: _vm.b('info')
    }, [_c('div', {
      staticClass: "tj-ellipsis",
      class: _vm.b('info__title')
    }, [_c('span', [_vm._v(_vm._s(_vm.unit.unitName))])]), _vm._t("desc-price-right"), _vm.unit.unitSummeries && _vm.unit.unitSummeries.length ? _c('div', {
      class: [_vm.b('info__desc'), {
        'tj-ellipsis': !_vm.isNeedEllipsisCpd
      }]
    }, _vm._l(_vm.unit.unitSummeries, function (item, index) {
      return _c('span', {
        key: index,
        ref: "houseTagText",
        refInFor: true,
        class: _vm.b('info__desc__text', {
          split: true
        }),
        style: _vm.summeriesTagStyle(item)
      }, [_vm._v(_vm._s(_vm.houseTagTextFormat(item.textType, item.text, index))), _c('span', {
        staticClass: "tag-dot"
      }, [_vm._v(_vm._s(index !== _vm.unit.unitSummeries.length - 1 ? '·' : ''))])]);
    })) : _vm._e(), Array.isArray(_vm.unit.houseTags) && _vm.unit.houseTags.length > 0 ? _c('div', {
      class: _vm.b('info__tags')
    }, [_vm._l(_vm.unit.houseTags, function (t, i) {
      return _c('span', {
        key: i,
        staticClass: "info__tag",
        class: {
          'tj-hairline--surround': _vm.haveTagBorder(t)
        },
        style: _vm.houseTagStyle(t)
      }, [_vm._v(_vm._s(t.text))]);
    }), _c('span', {
      class: _vm.b('info__tags__overlay')
    })], 2) : _c('div', {
      staticClass: "tags__blank"
    }), _vm._t("price-right"), _c('div', {
      class: _vm.b('info__price')
    }, [_c('div', {
      staticClass: "card-footer"
    }, [_vm.unit.failType === 9 ? _c('div', {
      staticClass: "left"
    }, [_vm._v("\n          " + _vm._s(_vm.unit.priceMissingText) + "\n        ")]) : _vm.unit.finalPrice <= 0 ? _c('div', {
      staticClass: "left"
    }, [_vm._v("\n          " + _vm._s(_vm.unit.priceMissingText || '暂无价格') + "\n        ")]) : _c('div', {
      staticClass: "left"
    }, [_c('div', {
      staticClass: "final-price"
    }, [_c('span', {
      staticClass: "mark"
    }, [_vm._v("￥")]), _c('span', {
      staticClass: "num"
    }, [_vm._v(_vm._s(_vm.unit.finalPrice))]), _vm.unit.finalPriceDisplayType === 1 ? _c('span', {
      staticClass: "separator"
    }, [_vm._v("/")]) : _vm._e(), _vm.unit.finalPriceDisplayType === 1 ? _c('span', {
      staticClass: "night"
    }, [_vm._v("晚")]) : _vm._e(), _vm.unit.displayOrigionPrice ? _c('div', {
      staticClass: "origion-price"
    }, [_c('span', [_vm._v("￥" + _vm._s(_vm.unit.productPrice))])]) : _vm._e()]), _c('div', {
      staticClass: "final-price-right"
    }, [_vm.unit.priceTipBadge && _vm.isShowPromotion ? _c('div', {
      staticClass: "dacu-text",
      style: _vm.priceTipBadgeStyle(_vm.unit.priceTipBadge)
    }, [_c('i', {
      staticClass: "icon-unit-sound"
    }), _vm._v("\n              " + _vm._s(_vm.unit.priceTipBadge.text) + "\n            ")]) : _vm._e(), _vm.unit.urgencyTip ? _c('div', {
      staticClass: "urgency-tip tj-ellipsis"
    }, [_vm._v(_vm._s(_vm.unit.urgencyTip))]) : _vm._e()])]), _vm.unit.logoUrl ? _c('div', {
      staticClass: "u-logo right"
    }, [_c('img', {
      staticClass: "user-avatar",
      attrs: {
        "src": _vm.unit.logoUrl
      }
    }), _vm.unit.great ? _c('span', {
      staticClass: "great-con"
    }, [_c('i', {
      staticClass: "icon-great"
    })]) : _vm._e()]) : _vm._e()])])], 2), _vm.unit.failType ? _c('div', {
      class: _vm.b('overlay')
    }) : _vm._e()]) : _vm._e();
  },
  name: 'unit-item-2',
  serverCacheKey: function serverCacheKey(props) {
    return props.unit.unitId;
  },
  props: {
    /**
     * 房屋数据，强制格式
     * @type {Object}
     */
    unit: {
      type: Object
    },

    /**
     * 房屋跳转地址,无地址自动跳转默认地址
     * @type {String}
     */
    unitUrl: {
      type: String
    },

    /**
     * 是否开启点击功能，禁用自动跳转
     * @type {Boolean}
     */
    isEnableClick: {
      type: Boolean,
      default: false
    },

    /**
     * 是否开启多张图片
     * @type {Boolean}
     */
    isSwipe: {
      type: Boolean,
      default: false
    },

    /**
     * 是否显示收藏
     * @type {Boolean}
     */
    isShowFavorite: {
      type: Boolean,
      default: true
    },

    /**
     * 是否显示头像
     * @type {Boolean}
     */
    isShowAvatar: {
      type: Boolean,
      default: true
    },

    /**
     * 是否显示标签配置
     * @type {Boolean}
     */
    isShowTags: {
      type: Boolean,
      default: false
    },

    /**
     * 是否显示促销信息
     * @type {Boolean}
     */
    isShowPromotion: {
      type: Boolean,
      default: true
    },

    /**
     * 是否显示品质认证信息
     * @type {Boolean}
     */
    isShowQualityCertification: {
      type: Boolean,
      default: true
    },

    /**
     * 边框Radius
     * @type {String}
     */
    borderRadius: {
      type: String,
      default: '6px'
    },

    /**
     * 背景色
     * @type {String}
     */
    background: {
      type: String,
      default: '#fff'
    } // /**
    //  * 内间距
    //  * @type {String}
    //  */
    // padding: {
    //   type: String,
    //   default: '20px'
    // }

  },
  data: function data() {
    return {
      // 是否mounted状态
      isMounted: false
    };
  },
  computed: {
    /**
     * 计算属性: 房屋卡片layout的样式style
     * @returns {Object} style object
     */
    layoutStyleCpd: function layoutStyleCpd() {
      return {
        background: this.background
      };
    },
    isNeedEllipsisCpd: function isNeedEllipsisCpd() {
      return this.unit.unitSummeries.find(function (item) {
        return item.text.indexOf('直线') > -1;
      });
    },

    /**
     * 计算属性: 图片样式Style
     * @returns {Object} style object
     */
    imgLayoutStyleCpd: function imgLayoutStyleCpd() {
      return {
        borderTopRightRadius: this.borderRadius,
        borderTopLeftRadius: this.borderRadius
      };
    },

    /**
     * 计算属性: 房屋卡片跳转Url
     * @returns {String}
     */
    navUrlCpd: function navUrlCpd() {
      var url = '';

      if (this.unitUrl) {
        url = this.unitUrl;
      } else {
        if (this.isMounted) {
          // 根据环境获取当前的URL
          var env = envHelper.getTujiaEnv();

          if (env && env.indexOf('.') === -1) {
            env = '.' + env;
          }

          var protocol = 'http' + (env === 'dev' ? '' : 's');
          url = protocol + "://m" + env + ".tujia.com/detail/" + this.unit.unitId + '.htm';
        } else {
          url = 'https://m.tujia.com/detail/' + this.unit.unitId + '.htm';
        }
      }

      return url;
    } // 后续增加打点恢复代码
    // indicatorCountCpd() {
    //   if (!this.unit || !this.unit.pictureList || this.unit.pictureList.length === 0) return 0;
    //   return this.unit.pictureList.length > 7 ? 7 : this.unit.pictureList.length;
    // }

  },
  mounted: function mounted() {
    this.isMounted = true;
  },
  methods: {
    /**
     * 收藏点击事件
     */
    favoriteClick: function favoriteClick() {
      // 未有前置数据前特殊处理
      if (this.unit.isFavorite === undefined || this.unit.isFavorite === null) {
        this.$set(this.unit, 'isFavorite', false);
      }

      this.$emit('favoriteClick', this.unit);
    },

    /**
     * 房屋卡片点击事件
     */
    unitClick: function unitClick() {
      if (this.isEnableClick) {
        this.$emit('click', this.unit);
      } else {
        // 如果是m站点，自动使用router
        if (/^m([1-9]?.fvt)?.tujia.com/.test(window.location.href)) {
          this.router.push('/detail/' + this.unit.unitId + '.htm');
        } else {
          window.location.href = this.navUrlCpd;
        }
      }
    },
    // 后续增加打点恢复
    indicatorAutoBem: function indicatorAutoBem(bemClassName, positionIndex, activeIndex) {
      positionIndex = positionIndex - 1;
      var stateName = '';

      if (Math.abs(activeIndex - positionIndex) >= 2 && (positionIndex === 0 || positionIndex === this.indicatorCountCpd - 1)) {
        stateName = 'small';
      }

      if (activeIndex === positionIndex || positionIndex === this.indicatorCountCpd - 1 && activeIndex >= this.indicatorCountCpd - 1) {
        stateName = 'active';
      }

      return this.b(bemClassName, stateName);
    },
    summeriesTagStyle: function summeriesTagStyle(t) {
      // "textType": "REALPHOTO",
      if (t.textType === 'REALPHOTO') {
        return {
          color: '#ff9645'
        };
      }
    },
    haveTagBorder: function haveTagBorder(t) {
      var isHaveTagBorder = t.border && t.border.width > 0;
      return isHaveTagBorder;
    },
    houseTagStyle: function houseTagStyle(t) {
      return {
        color: t.color,
        backgroundColor: t.background.color
      };
    },

    /** 房屋卡片底部 价格 促销信息
     * @param {Object} style 接口样式
     * @return {Object} 符合vue风格的样式
     */
    priceTipBadgeStyle: function priceTipBadgeStyle(style) {
      if (style) {
        var color = style.color,
            gradient = style.gradient;
        return {
          color: color,
          borderRadius: '7px',
          backgroundImage: "linear-gradient(-270deg, " + gradient.endColor + " 1%, " + gradient.startColor + " 99%)"
        };
      }
    },

    /** 房屋卡片底部 图片标签
     * @param {Object} style 接口样式
     * @return {Object} 符合vue风格的样式
     */
    houseListTagStyle: function houseListTagStyle(style) {
      if (style) {
        var imageUrl = style.imageUrl,
            width = style.width,
            height = style.height;
        return {
          position: 'absolute',
          bottom: '4px',
          left: '4px',
          width: width / 2 + "px",
          height: height / 2 + "px",
          backgroundImage: "url(" + imageUrl + ")",
          backgroundSize: 'contain'
        };
      }
    },
    topListTagStyle: function topListTagStyle(style) {
      if (style) {
        var color = style.color,
            gradient = style.gradient;
        return {
          color: color,
          borderRadius: '10px',
          backgroundImage: "linear-gradient(to right, " + gradient.endColor + " , " + gradient.startColor + ")"
        };
      }
    },
    houseTagTextFormat: function houseTagTextFormat(type, text, index) {
      var _this = this;

      if (type === 'UNITINFOR' && text.indexOf('直线') > -1) {
        this.$nextTick(function () {
          var textSplitArr = text.split('直线');
          var targetElement = _this.$refs.houseTagText[index];
          var targetElementWidth = targetElement.getBoundingClientRect().width;
          var parentElement = targetElement.parentElement;
          var parentElementWidth = parentElement.clientWidth;
          var otherElementWidth = 0;

          if (targetElement.className.indexOf('formate') > -1) {
            return false;
          }

          _this.$refs.houseTagText.map(function (tag) {
            if (tag.innerText.indexOf('直线') < 0) {
              otherElementWidth += tag.getBoundingClientRect().width;
            }
          });

          var _width = otherElementWidth + targetElementWidth - parentElementWidth;

          if (_width < 0 || _width === 0) {
            targetElement.innerText = text;
            return false;
          }

          if (_width > 0 && _width <= 20) {
            targetElement.innerText = textSplitArr[0].substr(0, 3) + '…直线' + textSplitArr[1];
          } else if (_width > 20 && _width <= 40) {
            targetElement.innerText = textSplitArr[0].substr(0, 2) + '…直线' + textSplitArr[1];
          } else if (_width > 40 && _width <= 60) {
            targetElement.innerText = textSplitArr[0].substr(0, 1) + '…直线' + textSplitArr[1];
          } else if (_width > 60) {
            targetElement.innerText = '距…';
          }

          targetElement.className += ' formate';
        });
      }

      return text;
    }
  },
  filters: {
    /**
     * 过滤器: tag style
     * @param {Object} tag tag对象
     * @returns {Object} style
     */
    tagStyleFilter: function tagStyleFilter(tag) {
      if (!tag) return null;
      return {
        color: tag.color,
        backgroundColor: tag.background && tag.background.color
      };
    }
  },
  component: {
    TjSwipe: TjSwipe
  }
});